// Required for Angular multi-browser support
import { BrowserModule } from '@angular/platform-browser';

// Required for Angular
import { APP_INITIALIZER, NgModule } from '@angular/core';

// Required modules and components for this application
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './components/header/header.component';
import { ProfileComponent } from './components/profile/profile.component'
import { PurchasedComponent } from './components/purchased/purchased.component';
import { ActivatedComponent } from './components/activated/activated.component';
import { BsolveAngularControlsLibModule } from '@bsolve/bsolve-angular-controls-lib';
import { SprobotconfigService } from '../services/sprobotconfigservice.service'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// HTTP modules required by MSAL
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

// Required for MSAL
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent, ProtectedResourceScopes } from '@azure/msal-angular';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function init_configService(appConfigService: SprobotconfigService) {
  return () => appConfigService.init();
}

/*
    auth: {
      // 'Application (client) ID' of app registration in the Microsoft Entra admin center - this value is a GUID
      clientId: "bd0b5a49-c68b-4adc-8039-47d109b06020",
      // Full directory URL, in the form of https://login.microsoftonline.com/<tenant>
      authority: "https://login.microsoftonline.com/common",
      // Must be the same redirectUri as what was provided in your app registration.
      redirectUri: "https://localhost:4200/",
    }
    */

export function MSALInstanceFactory(
  sprobotConfigService: SprobotconfigService
): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: sprobotConfigService.getSetting('saasClientID').propertyValue,
      //clientId: "bd0b5a49-c68b-4adc-8039-47d109b06020",
      //authority:
      //  sprobotConfigService.getSetting('AzureActiveDirectory:Instance')
      //    .propertyValue +
      //  sprobotConfigService.getSetting('AzureActiveDirectory:TenantId')
      //    .propertyValue,
      authority: "https://login.microsoftonline.com/common",
      redirectUri: sprobotConfigService.getSetting('landingredirectUrl').propertyValue,
      //redirectUri: "https://localhost:4200/",
      clientCapabilities: ['CP1'], // This lets the resource server know that this client can handle claim challenges.
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      /**
       * Below you can configure MSAL.js logs. For more information, visit:
       * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
       */
      loggerOptions: {
        loggerCallback(logLevel: LogLevel, message: string) {},
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false,
      },
    },
  });
}

// MSAL Interceptor is required to request access tokens in order to access the protected resource (Graph)
export function MSALInterceptorConfigFactory(
  sprobotConfigService: SprobotconfigService
): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<
    string,
    Array<string | ProtectedResourceScopes> | null
  >();
  protectedResourceMap.set(
    sprobotConfigService.getSetting('Cors:AuthAPIPublic').propertyValue,
    [sprobotConfigService.getSetting('scopeUrl').propertyValue]
  );

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: protectedResourceMap,
  };
}

// MSAL Guard is required to protect routes and require authentication before accessing protected routes
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read']
    }
  };
}

// Create an NgModule that contains the routes and MSAL configurations
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    ProfileComponent,
    PurchasedComponent,
    ActivatedComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MsalModule,
    BsolveAngularControlsLibModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    SprobotconfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: init_configService,
      deps: [SprobotconfigService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
      deps: [SprobotconfigService],
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
      deps: [SprobotconfigService],
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
      deps: [SprobotconfigService],
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
